import { PropsWithChildren } from 'react';
import { BoxProps, Flex } from 'reflexbox';
import styled from 'styled-components';

import Absolute from './Absolute';

const Container = styled.div`
	position: relative;

	width: 100%;
	height: 100%;
`;

const Placeholder = styled.div<{ showBounds: boolean }>`
	box-sizing: border-box;

	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;

	color: ${(props) => props.theme.colors.slateBlue};
	font-size: 7mm;
	${(props) => (props.showBounds ? `border: 1mm dashed ${props.theme.colors.slateBlue};` : '')}
`;

export default function BoundingBox({
	showBounds,
	showTitle,
	title,
	children,
}: {
	showBounds?: boolean;
	showTitle?: boolean;
	title?: string;
} & PropsWithChildren<BoxProps>) {
	return (
		<Container>
			{showBounds && (
				<Absolute stretchToBounds>
					<Placeholder showBounds={showBounds}>
						{showTitle && title && (
							<Flex justifyContent="center" alignItems="center" height="100%">
								<Flex flexDirection="column" justifyContent="center" alignItems="center">
									{title}
								</Flex>
							</Flex>
						)}
					</Placeholder>
				</Absolute>
			)}
			<Absolute stretchToBounds>{children}</Absolute>
		</Container>
	);
}
